export default __webpack_public_path__ + "static/media/Piraten-Kapern-rulebook.f9c4d0c9.pdf";